export default {
  title: 'Countries',
  importExport: 'Import/Export',
  countriesConfig: 'Countries Config',
  close: 'Close',
  save: 'Save',
  json: 'JSON',
  noData: 'No data',
  headerName: 'Name',
  headerIsoCode: 'ISO Code',
  headerTrpCost: 'TRP Cost',
  headerWeeklyMinSpend: 'Weekly Min. Spend',
  validationJsonRequired: 'JSON is required',
  validationInvalidJson: 'Invalid JSON',
  validationInvalidCountries: 'Invalid Countries'
}
